/**
 * The bounds the API holds tracks and cohorts to; the admin console's forms
 * use the same numbers. A pilot of more than a year is a typo, not a plan.
 */
export const TRACK_LIMITS = {
  title: 200,
  pilotWeeks: 52,
} as const;
